import React from "react";

import ColorInit from "../helper/ColorInit";
import Preloader from "../helper/Preloader";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import Banner from "../components/Banner";
import Services from "../components/Services";
import TopVendors from "../components/TopVendors";
import RecentlyViewed from "../components/RecentlyViewed";
import Brand from "../components/Brand";
import Shipping from "../components/Shipping";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import BottomFooter from "../components/BottomFooter";
import AddressList from "../components/Address/AddressList";

const AddressPage = () => {


  return (

    <div className="bg-white">
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* Preloader */}
      <Preloader />

      {/* Header */}
      <Header category={false} />

      {/* Breadcrumb */}
      <Breadcrumb title={"My Address"} />

      {/* AddressList */}
      <AddressList />

      {/* Footer */}
      <Footer />

      {/* BottomFooter */}
      <BottomFooter />


    </div>
  );
};

export default AddressPage;
